// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".fcis-vehicle-selector-title-step__title{margin-bottom:var(--wb-spacing-m)}.fcis-vehicle-selector-title-step__image-wrapper{text-align:center}.fcis-vehicle-selector-title-step__image{width:100%;max-width:270px}@media(min-width:48em){.fcis-vehicle-selector-title-step__image{display:none}}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
